import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { BusinessDtoKeysEnum } from '@zaoblako/shared/modules/business/enum/business-dto-keys.enum';

import * as yup from 'yup';

/** Deal event rescheduling parameters */
export interface DealEventRescheduleInterface {
  /** New event start date */
  startAt: Date;
  /** New planned end date of the event */
  endAt: Date;
  /** Comment describing the reason for rescheduling */
  reason: string;
}

/** Deal event rescheduling parameters - DTO schema */
export const DealEventRescheduleDto = SerdeDtoClass.create<DealEventRescheduleInterface>(BusinessDtoKeysEnum.DEAL_EVENT_RESCHEDULING_DTO, {
  startAt: {
    label: 'Начало',
    serializer: yup.date(),
  },
  endAt: {
    label: 'Конец',
    serializer: yup.date(),
  },
  reason: {
    label: 'Причина',
    serializer: yup.string().required(DtoMessageEnum.EMPTY_STRING),
  },
});
